var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c(
        "div",
        { staticClass: "p-20" },
        [
          _c("div", { staticClass: "disp-flex" }, [
            _c("div", { staticClass: "mb-20" }, [
              _c(
                "h1",
                { staticClass: "mt-0" },
                [
                  _vm.currentTemplate
                    ? [
                        _vm.currentTemplate.template_id
                          ? _c(
                              "div",
                              [
                                _c("svg-icon", {
                                  attrs: { "icon-class": "file-code-solid" }
                                }),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("templateDetailTitle", {
                                        value: _vm.currentTemplate.template_id
                                      })
                                    ) +
                                    "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.translate_template_id(
                                        _vm.currentTemplate.template_id
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t—\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$translate.channel(
                                        _vm.currentTemplate.channel
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t—\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$translate.language(
                                        _vm.currentTemplate.locale
                                      )
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c("svg-icon", {
                                  attrs: { "icon-class": "file-code-solid" }
                                }),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("templateDetailTitle", {
                                        value: "[No document name.]"
                                      })
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ],
                              1
                            )
                      ]
                    : _vm._e()
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _vm.currentTemplate &&
                  (_vm.currentTemplate.channel === "EMAIL" ||
                    _vm.currentTemplate.channel === "MAIL" ||
                    _vm.currentTemplate.channel === "SMS" ||
                    _vm.currentTemplate.channel === "NONE")
                    ? [
                        _c(
                          "div",
                          [
                            _vm.currentTemplate.type === "WORD" ||
                            _vm.currentTemplate.type === "WORD2"
                              ? [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "mb-20",
                                              attrs: {
                                                type: "primary",
                                                loading: _vm.downloadLoading
                                              },
                                              on: { click: _vm.handleDownload }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "downloadWordRendered"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: {
                                                click:
                                                  _vm.handleDownloadWordTemplate
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "downloadWordTemplate"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c("div", [
                                            _c("input", {
                                              ref: "file",
                                              staticClass: "inputfile",
                                              attrs: {
                                                id: "file",
                                                accept:
                                                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                                type: "file",
                                                name: "file"
                                              },
                                              on: {
                                                change: _vm.handleFileChange
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "cursor-pointer",
                                                attrs: { for: "file" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("chooseFileToUpload")
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.selectedFile
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mb-15" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("selectedFile")
                                                      ) +
                                                        ": " +
                                                        _vm._s(_vm.selectedFile)
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _vm.selectedFile
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: _vm.handleUpload
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t("uploadWord")
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentTemplate.type === "LIQUID" ||
                            _vm.currentTemplate.type === "PYTHON_TEMPLATE"
                              ? [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                                loading: _vm.downloadLoading
                                              },
                                              on: { click: _vm.handleDownload }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t("downloadExample")
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.currentTemplate
                                            .template_renderer_version === "v3"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "success",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.handleSaveTemplate
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(_vm.$t("save")) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dev
                                            ? _c(
                                                "span",
                                                { staticClass: "dev" },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: { size: "mini" },
                                                      on: {
                                                        click:
                                                          _vm.handleToggleRawEditor
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Toggle raw editor"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        value:
                                                          _vm.currentTemplate
                                                            .template_renderer_version,
                                                        loading:
                                                          _vm.loadingUpdateTemplateRendererVersion,
                                                        size: "mini"
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.handleTemplateRendererVersionChange
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-option",
                                                        {
                                                          attrs: { value: "v2" }
                                                        },
                                                        [_vm._v("V2")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-option",
                                                        {
                                                          attrs: { value: "v3" }
                                                        },
                                                        [_vm._v("V3")]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "dev__label"
                                                    },
                                                    [_vm._v("DEV")]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("el-row", [
                                    _vm.currentTemplate.channel === "EMAIL"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-form",
                                              {
                                                ref: "form",
                                                attrs: {
                                                  model: _vm.subjectForm,
                                                  "label-width": "120px",
                                                  "label-position": "top"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "subjectTemplate"
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      model: {
                                                        value:
                                                          _vm.subjectForm
                                                            .subject,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.subjectForm,
                                                            "subject",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "subjectForm.subject"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "gjs__container" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "gjs__content" },
                                          [
                                            _vm.showRawEditor ||
                                            _vm.currentTemplate.channel ===
                                              "SMS"
                                              ? _c("div", [
                                                  _vm.currentTemplate
                                                    .channel === "SMS"
                                                    ? _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.tinymcecontent,
                                                            expression:
                                                              "tinymcecontent"
                                                          }
                                                        ],
                                                        staticClass: "gjs",
                                                        staticStyle: {
                                                          height:
                                                            "240px !important",
                                                          width: "480px"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.tinymcecontent
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.tinymcecontent =
                                                              $event.target.value
                                                          }
                                                        }
                                                      })
                                                    : _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.tinymcecontent,
                                                            expression:
                                                              "tinymcecontent"
                                                          }
                                                        ],
                                                        staticClass: "gjs",
                                                        staticStyle: {
                                                          width: "100%"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.tinymcecontent
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.tinymcecontent =
                                                              $event.target.value
                                                          }
                                                        }
                                                      })
                                                ])
                                              : _c("div", [
                                                  _c("div", {
                                                    staticClass: "gjs",
                                                    attrs: { id: "gjs" }
                                                  })
                                                ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.currentTemplate
                                          .template_renderer_version !== "v3"
                                          ? _c(
                                              "div",
                                              { staticClass: "gjs__overlay" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "template.detail.contact_support"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ])
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    : _c("div", [_c("loader", { staticClass: "mt-50 mb-50 ml-50" })], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }